import { parse, stringify } from 'qs';

export const isGray = /gray/.test(window.location.host);

// 测试、灰度环境一致，生产环境没有 'gray'
export function getHost() {
    let host = '//abroad-sin.shengqugames-corp.com';
    if (isGray) host = '//abroad-sin-gray.shengqugames-corp.com';
    return host;
}

/** 特殊的错误码 */
export const ErrorCode = {
    CaptchaError: -4100605, // 邮箱验证码校验失败
    NoPassword: -4100606, // 用户密码未设置
    PasswordFormatError: -4100608, // 密码格式错误
    UnknownReturnUrl: -10403007, // 未知的 return url （查询小票报的错）
    NoLogin: -4100027, // 未登录
};

export const defaultConfig = {
    baseURL: getHost(),
    timeout: 15000,
    headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    paramsSerializer: {
        encode: parse,
        serialize: stringify,
    },
};
